import * as yup from 'yup';

import { useYupValidators } from '~/utils/yupValidators';

const useExpressUnionSchema = () => {
  const yupValidators = useYupValidators();
  const expressUnionSchema = yup.object().shape({
    number: yupValidators.numberExpressUnion,
    indicatif: yupValidators.indicatifExpressUnion,
  });

  return { expressUnionSchema };
};

export { useExpressUnionSchema };
